/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface IrrReConfigAuthUi { 
    clientId?: string;
    clientSecret?: string;
    defaultRedirectUri?: string;
    redirectUris?: Array<string>;
    type?: string;
}

